import React from 'react';
import { TextField } from "@mui/material";
import dayjs, { Dayjs } from 'dayjs';
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { format } from "date-fns";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";

import Stack from '@mui/material/Stack';
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import LoadingButton from "@mui/lab/LoadingButton";
import { useState, useEffect } from 'react';
import { FetcherWithComponents } from 'react-router-dom';
import { CMAddressBook, GetAddressBookDetailsResponse } from "services/apiService";
import { HomeAction } from 'views/home/Home';
import TimezonesInput from './../../components/TimezonesInput';
import axiosInstance from "services/axiosInstance";
import { ToastContainer } from 'react-toastify';



interface ScheduleCampaingFormProps {
    open: boolean;
    onClose: () => void;
    fetcher: FetcherWithComponents<any>;
    addressBooks: CMAddressBook[],
    campaignId: number,
    sender: string,
    schedule_date: string,
    campaignCmId: string,
    cm_group_id: string
}

const ScheduleCampaingForm = ({ open, onClose, fetcher, addressBooks, campaignId, sender, schedule_date, campaignCmId, cm_group_id
}: ScheduleCampaingFormProps) => {
    const theme = useTheme();
    const [campaing, setCampaing] = useState({
        sender: sender,
        groups: []
    })

    const [addressBook, setAddressBook] = useState<GetAddressBookDetailsResponse | null>(null);

    const [scheduledDateTime, setScheduledDateTime] = React.useState<Date | null>(new Date(schedule_date));
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    const [timezone, setTimezone] = React.useState(localTimezone);

    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCampaing({ ...campaing, [e.target.name]: e.target.value })
    }

    const handleTimeZoneChange = (newValue: any) => {
        setTimezone(newValue);
    }

    useEffect(() => {
        onClose();
    }, [fetcher.data, onClose]);

    useEffect(() => {
        onClose();
    }, [fetcher.data, onClose]);

    useEffect(() => {
        (async () => {
            try {
                let ads = await axiosInstance
                    .get<GetAddressBookDetailsResponse>(
                        (
                            process.env
                                .REACT_APP_API_CM_GET_ADDRESS_BOOK_DETAILS_ENDPOINT as string
                        ).replace(":cmGroupId", cm_group_id)
                    )
                    .then((response) => response.data)
                setAddressBook(ads || null);
            } catch (error) {
                console.log(
                    `Error while getting addressBook details':`,
                    error
                );
            }
        })();
    }, []);

    return (
        <Dialog open={open} onClose={onClose} fullWidth >
            <DialogTitle>Schedule campaing</DialogTitle>
            <ToastContainer />
            <DialogContent>
                <fetcher.Form
                    method="post"
                    id="scheduleCampaingForm"
                    style={{ marginTop: theme.spacing(1), marginBottom: theme.spacing(1) }}
                >
                    <Stack spacing={4}>
                        <TextField
                            required
                            id="outlined-required"
                            label="Sender"
                            size="small"
                            name="sender"
                            value={campaing.sender}
                            onChange={handleValueChange}
                        />
                        <TimezonesInput handleTimeZoneChange={handleTimeZoneChange} localTimezone={"Europe/Paris"} />
                        <DateTimePicker
                            renderInput={(params) => (
                                <TextField fullWidth required {...params} size="small" />
                            )}
                            label="Scheduled Date & Time"
                            value={scheduledDateTime}
                            inputFormat="dd/MM/yyyy HH:mm"
                            // onChange={(e) => { handleChangeDate(e) }}
                            onChange={(newValue) => {
                                setScheduledDateTime(newValue);
                            }}
                            ampm={false}
                            disablePast={true}
                        />
                        <TextField
                            id="outlined-required"
                            label="Contacts Amount"
                            size="small"
                            name="contactsAmount"
                            value={addressBook?.details.contactsAmount}
                            aria-readonly={true}
                        />
                        {/* <Autocomplete
                            value={addressBook}
                            onChange={(_, newValue) => {
                                setAddressBook(newValue);
                            }}
                            disablePortal
                            options={addressBooks}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                                <TextField required {...params} label="Recipients" size="small" />
                            )}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.name}
                                </li>
                            )}
                        /> */}
                        <TextField
                            id="outlined-required"
                            label="Recipients"
                            size="small"
                            name="recipients"
                            value={addressBook?.details.name}
                            aria-readonly={true}
                            helperText={addressBook?.details.name}
                        />

                        <input type="text" name="group_id" value={addressBook?.details.id} hidden readOnly />
                        <input type="hidden" name="action" value={HomeAction.ScheduleCampaing} />
                        <input type="text" name="timezone" value="Europe/Paris" hidden readOnly />
                        <input
                            type="text"
                            name="campaignScheduleDateTime"
                            value={
                                scheduledDateTime
                                    ? format(scheduledDateTime, "yyyyMMdd HH:mm").replace(":", "h")
                                    : ""
                            }
                            hidden
                            readOnly
                        />
                        <input
                            type="text"
                            name="localcampaignScheduleDateTime"
                            value={
                                scheduledDateTime
                                    ? format(scheduledDateTime, "yyyy-MM-dd HH:mm")
                                    : ""
                            }
                            hidden
                            readOnly
                        />
                        <input
                            type="text"
                            name="campaignScheduleDate"
                            value={
                                scheduledDateTime
                                    ? format(scheduledDateTime, "yyyyMMdd")
                                    : ""
                            }
                            hidden
                            readOnly
                        />
                        <input
                            type="text"
                            name="campaignScheduleTime"
                            value={
                                scheduledDateTime
                                    ? format(scheduledDateTime, "HH:mm").replace(":", "h")
                                    : ""
                            }
                            hidden
                            readOnly
                        />
                        <input type="text" name="campaignCmId" value={campaignCmId} hidden readOnly />
                    </Stack>

                </fetcher.Form>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>

                <LoadingButton
                    type="submit"
                    form="scheduleCampaingForm"
                    loading={fetcher.state === "submitting"}
                // onClick={scheduleCampaingAction}
                >
                    Schedule
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default ScheduleCampaingForm;